/* eslint-disable prefer-promise-reject-errors */
import { CheckOutlined, MailOutlined, PhoneOutlined, PlusCircleFilled } from "@ant-design/icons";
import { useMutation } from "@apollo/client";
import { Button, Form, Input, message, Popover, Select } from "antd";
import { capitalize, isEmpty } from "lodash";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../amplify/authenticator-provider";
import {
  CREATE_LEAD_ADDRESS,
  UPDATE_LEAD_ADDRESS,
  UPDATE_LEAD_PREFFREDLANGUAGE,
} from "../../../graphql/mutation";
import useCrmIntegration from "../../../hooks/useCrmIntegration";
import useLang from "../../../hooks/useLang";
import LocationIcon2 from "../../../icons/js/LeadProfileIcons/LocationIcon";
import { EditPencilIcon } from "../../../icons/js/PencilIcon";
import { parseAddress } from "../../../library/utils";
import { EmailForm } from "./EmailForm";
import { PhoneFormJsx } from "./PhoneFormJsx";
import LeadSummaryOpenAi from "./leadSummaryOpenAi";
import { createLeadAddressRedux, updateLeadAddressRedux } from "../../../redux/slices/leadSlice";

export const AboutThisLead = ({
  setSelectedLead,
  getMessages,
  leadList,
  setLeadList,
  languages,
}) => {
  const { selectedLead } = useSelector(state => state.lead);
  const { user } = useContext(UserContext);
  const phoneRef = useRef(null);
  const addressRef = useRef(null);
  const newEmail = useRef();
  const [lang] = useLang();
  const crmIntegration = useCrmIntegration();
  const phoneArr = ["Mobile", "Work"];
  if (crmIntegration === "DS") {
    phoneArr.push("Other");
  } else if (crmIntegration === "") {
    phoneArr.push("Other", "Home");
  } else {
    phoneArr.push("Home");
  }

  const [hoverEdit, sethoverEdit] = useState({
    phone: false,
    email: false,
    address: false,
  });
  const address = useMemo(() => {
    return (
      selectedLead?.addresses &&
      (selectedLead?.addresses || []).length > 0 &&
      selectedLead.addresses[0]
    );
  }, [selectedLead]);

  const remainingPhoneNumbers = useMemo(() => {
    const phoneNumbers = selectedLead?.phoneNumbers || [];
    const combinedPhoneTypes = [
      ...phoneNumbers.map(item => capitalize(item.phoneType)),
      ...phoneArr,
    ];
    const outersected = combinedPhoneTypes.filter(item => {
      return !(
        phoneNumbers.map(item => capitalize(item.phoneType)).includes(item) &&
        phoneArr.includes(item)
      );
    });
    return outersected;
  }, selectedLead?.phoneNumbers);
  // const [languages, setLanguages] = useState();
  const [updateLeadPreferredLanguage] = useMutation(UPDATE_LEAD_PREFFREDLANGUAGE);
  const addressString = parseAddress(address);
  return (
    <div className="flex-col-centered gap-2">
      <div className="flex-col-centered gap-3">
        {/* Lead Phone Numbers */}
        <div
          onMouseEnter={() => sethoverEdit({ phone: true })}
          onMouseLeave={() => sethoverEdit({ phone: false })}
          className="flex-row-centered items-start gap-1"
        >
          <PhoneOutlined className="rotate-90 mt-1" />
          <span className="flex-col-centered gap-1">
            {selectedLead?.phoneNumbers?.length > 0 ? (
              (selectedLead?.phoneNumbers || []).map((item, index) => (
                <span key={index} className="flex-row-centered items-center gap-1">
                  {item?.phone !== null ? formatPhoneNumberIntl(item?.phone) : "N/A"} (
                  {capitalize(item?.phoneType)}){" "}
                  {item?.isPrimary && <CheckOutlined className="text-green-500" />}
                  {index === 0 && (
                    <EditPhoneIcon
                      phoneRef={phoneRef}
                      selectedLead={selectedLead}
                      setSelectedLead={setSelectedLead}
                      phoneArr={phoneArr}
                      hoverEdit={hoverEdit}
                    />
                  )}
                </span>
              ))
            ) : (
              <Popover
                trigger="click"
                destroyTooltipOnHide
                content={
                  <PhoneFormJsx
                    phoneRef={phoneRef}
                    phones={(selectedLead?.phoneNumbers || [])
                      .filter(item => item) // Remove null values
                      .map(item => ({
                        ...item,
                        phoneType: item?.phoneType ? capitalize(item.phoneType) : "",
                      }))}
                    selectedLead={selectedLead}
                    setSelectedLead={setSelectedLead}
                    phoneArr={phoneArr}
                  />
                }
              >
                <span
                  ref={phoneRef}
                  className="flex-row-centered ml-1 cursor-pointer text-brand-500 items-center gap-1"
                >
                  <PlusCircleFilled /> Add phone{" "}
                </span>
              </Popover>
            )}
          </span>
        </div>
        {/* Lead Phone Numbers */}
        {/* Lead Email ids */}
        <div
          onMouseEnter={() => sethoverEdit({ email: true })}
          onMouseLeave={() => sethoverEdit({ email: false })}
          className="flex-row-centered items-start gap-1"
        >
          <MailOutlined className=" mt-1" />
          <span className="flex-col-centered gap-1">
            {(selectedLead?.emails || []).filter(item => item && item.email).length > 0 ? (
              (selectedLead?.emails || [])
                .filter(item => item.email)
                .map((item, index) => (
                  <span
                    key={index}
                    className="text-brand-500 flex-row-centered cursor-pointer gap-1 items-center ml-1"
                  >
                    <span
                      className="ellipsis max-w-[200px]"
                      onClick={() => window.open(`mailto:${item.email}`)}
                    >
                      {item.email}{" "}
                      {!isEmpty(item?.emailType) ? `(${capitalize(item?.emailType)})` : ""}
                    </span>
                    {item.isPrimary && <CheckOutlined className="text-green-500" />}
                    {index === 0 && (
                      <EditEmailIcon
                        newEmail={newEmail}
                        setSelectedLead={setSelectedLead}
                        selectedLead={selectedLead}
                        hoverEdit={hoverEdit}
                      />
                    )}
                  </span>
                ))
            ) : (
              <Popover
                trigger="click"
                destroyTooltipOnHide
                content={
                  <EmailForm
                    emailRef={newEmail}
                    setSelectedLead={setSelectedLead}
                    emails={selectedLead?.emails}
                  />
                }
              >
                <span
                  // onClick={() => newEmail.current.click()}
                  ref={newEmail}
                  className="flex-row-centered ml-1 cursor-pointer text-brand-500 items-center gap-1"
                >
                  <PlusCircleFilled /> Add Email
                  {/* <EditEmailIcon
                  newEmail={newEmail}
                  setSelectedLead={setSelectedLead}
                  selectedLead={selectedLead}
                  hoverEdit={hoverEdit}
                /> */}
                </span>
              </Popover>
            )}
          </span>
        </div>
        {/* Lead Email ids */}
        <div className="flex-row-centered items-start gap-1">
          <span className="-ml-1">
            <LocationIcon2 />
          </span>
          <span className="cursor-pointer">
            {isEmpty(addressString) ? (
              <Popover
                content={
                  <AddressForm mode="ADD" selectedLead={selectedLead} addressRef={addressRef} />
                }
                trigger={["click"]}
              >
                <div className="flex-row-centered text-brand-500 gap-1" ref={addressRef}>
                  <PlusCircleFilled className="text-brand-500" />
                  <span>Add Address</span>
                </div>
              </Popover>
            ) : (
              <Popover
                content={
                  <AddressForm
                    mode="EDIT"
                    selectedLead={selectedLead}
                    address={address}
                    addressRef={addressRef}
                  />
                }
                trigger={["click"]}
              >
                <div
                  onMouseEnter={() => sethoverEdit({ address: true })}
                  onMouseLeave={() => sethoverEdit({ address: false })}
                  ref={addressRef}
                >
                  {addressString}
                  <EditPencilIcon
                    className={`cursor-pointer ${hoverEdit.address ? "visible" : "invisible"}`}
                    color="#3B82F6"
                  />
                </div>
              </Popover>
            )}
          </span>
        </div>
      </div>
      <div className="flex-row-centered items-center justify-between">
        <span>{lang.preferredlang}</span>
        <Select
          className="w-[100px]"
          onChange={value => {
            updateLeadPreferredLanguage({
              variables: {
                leadId: selectedLead?.id,
                preferredLanguageCode: value,
              },
              onCompleted: res => {
                if (res?.updateLeadPreferredLanguage?.statusCode === 200) {
                  getMessages();
                  const arrayFn1 = () => {
                    const clone = structuredClone(selectedLead);
                    clone.preferredLanguageCode =
                      res?.updateLeadPreferredLanguage?.preferredLanguageCode;
                    return clone;
                  };
                  setSelectedLead(arrayFn1());
                  const arrayFn = () => {
                    const clone = structuredClone(leadList);
                    const newLeadList = clone?.map(item => {
                      if (+selectedLead?.id === +item?.id) {
                        return {
                          ...item,
                          preferredLanguageCode:
                            res?.updateLeadPreferredLanguage?.preferredLanguageCode,
                        };
                      }
                      return item;
                    });
                    return newLeadList;
                  };
                  setLeadList(arrayFn());
                }
              },
            });
          }}
          value={selectedLead?.preferredLanguageCode}
          placeholder={lang.preferredlang}
        >
          {(languages || []).map(item => (
            <Select.Option key={item?.id} value={item?.languageCode}>
              {item.languageName}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div className="flex-row-centered items-center justify-between">
        <LeadSummaryOpenAi
          key={selectedLead?.id}
          selectedLead={selectedLead}
          user={user}
          text="Generate"
          labelText="Otto 360 Overview"
        />
      </div>
    </div>
  );
};
function EditEmailIcon({ newEmail, setSelectedLead, selectedLead, hoverEdit }) {
  return (
    <Popover
      trigger="click"
      destroyTooltipOnHide
      content={
        <EmailForm
          emailRef={newEmail}
          setSelectedLead={setSelectedLead}
          emails={selectedLead?.emails}
        />
      }
    >
      <span className="cursor-pointer" onClick={e => e.stopPropagation()} ref={newEmail}>
        <EditPencilIcon
          className={`cursor-pointer ${hoverEdit?.email ? "visible" : "invisible"}`}
          color="#3B82F6"
        />
      </span>
    </Popover>
  );
}

function EditPhoneIcon({ phoneRef, selectedLead, setSelectedLead, phoneArr, hoverEdit }) {
  return (
    <Popover
      trigger="click"
      destroyTooltipOnHide
      content={
        <PhoneFormJsx
          phoneRef={phoneRef}
          phones={
            Array.isArray(selectedLead?.phoneNumbers)
              ? (selectedLead.phoneNumbers || []).map(item => ({
                  ...item,
                  phoneType: item?.phoneType ? capitalize(item.phoneType) : "",
                }))
              : []
          }
          selectedLead={selectedLead}
          setSelectedLead={setSelectedLead}
          phoneArr={phoneArr}
        />
      }
    >
      <span className="cursor-pointer" onClick={e => e.stopPropagation()} ref={phoneRef}>
        <EditPencilIcon
          className={`cursor-pointer ${hoverEdit.phone ? "visible" : "invisible"}`}
          color="#3B82F6"
        />
      </span>
    </Popover>
  );
}

const AddressForm = props => {
  const [form] = Form.useForm();
  console.log(props);
  const dispatch = useDispatch();
  const { address, addressRef, selectedLead, mode } = props;
  const close = () => addressRef.current.click();
  useEffect(() => {
    form.setFieldsValue(address);
  }, [address]);
  const [updateLeadAddress, { loading: updateleadAddressLoader }] =
    useMutation(UPDATE_LEAD_ADDRESS);
  const [createLeadAddress, { loading: createLeadAddressLoader }] =
    useMutation(CREATE_LEAD_ADDRESS);
  const handleSubmit = async value => {
    if (mode === "EDIT") {
      const res = await updateLeadAddress({
        variables: {
          id: address.id,
          ...value,
        },
      });
      if (res.data.updateLeadAddress.statusCode === 200) {
        message.success(res.data.updateLeadAddress.message);
        dispatch(updateLeadAddressRedux(res.data.updateLeadAddress.leadAddress));
        close();
      } else {
        message.error(res.data.updateLeadAddress.message);
      }
    } else {
      const res = await createLeadAddress({
        variables: {
          leadId: selectedLead.id,
          ...value,
        },
      });
      if (res?.data?.createLeadAddress?.statusCode === 200) {
        message.success(res?.data?.createLeadAddress?.message);
        dispatch(createLeadAddressRedux(res?.data?.createLeadAddress?.leadAddress));
        close();
      }
    }
  };
  return (
    <Form layout="vertical" form={form} onFinish={value => handleSubmit(value)}>
      <div className="flex-row-centered gap-1">
        <Form.Item
          className="w-full"
          name="addressLine1"
          // rules={[{ required: true, message: "Primary Address is required" }]}
          label="Address Line 1"
        >
          <Input name="addressLine1" placeholder="Enter Address Line 1" />
        </Form.Item>
        <Form.Item className="w-full" name="addressLine2" label="Address Line 2">
          <Input name="addressLine2" placeholder="Enter Address Line 2" />
        </Form.Item>
      </div>
      <div className="flex-row-centered gap-1">
        <Form.Item
          className="w-full"
          name="city"
          // rules={[{ required: true, message: "City is required" }]}
          label="City"
        >
          <Input name="city" placeholder="Enter City" />
        </Form.Item>
        <Form.Item
          className="w-full"
          name="state"
          // rules={[{ required: true, message: "State is required" }]}
          label="State"
        >
          <Input name="state" placeholder="Enter State" />
        </Form.Item>
      </div>
      <div className="flex-row-centered gap-1">
        <Form.Item
          className="w-full"
          name="postalCode"
          // rules={[{ required: true, message: "Postal Code is required" }]}
          label="Postal Code"
        >
          <Input type="number" name="postalCode" placeholder="Enter Postal Code" />
        </Form.Item>
        <Form.Item
          className="w-full"
          name="country"
          // rules={[{ required: true, message: "Country is required" }]}
          label="Country"
        >
          <Input name="country" placeholder="Enter Country" />
        </Form.Item>
      </div>
      <div className="flex-row-centered gap-1 justify-start">
        <Button
          loading={createLeadAddressLoader || updateleadAddressLoader}
          type="primary"
          htmlType="submit"
        >
          Save
        </Button>
        <Button onClick={close}>Cancel</Button>
      </div>
    </Form>
  );
};
